/**
 * This hashes any string to an 8-digit hex string.
 * This uses the djb2 algorithm, explained at https://theartincode.stanis.me/008-djb2/
 */
export function djb2Hash(s: string): string {
  let hash = 5381;
  for (const c of s.split('')) {
    hash = ((hash << 5) + hash + c.charCodeAt(0)) & 0xffffffff;
  }
  return Math.abs(hash).toString(16);
}
